import mixin from "../../../mixins/mixin";
import formService from "../../../services/form";
import Datepicker from "vuejs-datepicker";
import TimePicker from "vue2-timepicker";

export default {
  data() {
    return {
      form: {},
      loading: true,
      minutes: ["00", "15", "30", "45"],
      hours: [],
      timeInHours: [],
      timeOutHours: [],
      rentalTimeIn: "",
      rentalTimeOut: "",
    };
  },
  components: {
    VLoading: require("components/loading/loading.vue"),
    Datepicker,
    VueTimepicker: TimePicker,
  },
  mixins: [mixin],
  async mounted() {
    let vm = this;
    if (vm.$route.params.id) {
      await formService.previewForm(this, vm.$route.params.id);
    }

    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < vm.minutes.length; j++) {
        i < 10
          ? vm.hours.push(`0${i}:${vm.minutes[j]}`)
          : vm.hours.push(`${i}:${vm.minutes[j]}`);
      }
    }
    vm.timeInHours = vm.getTimeInHourRange();
    vm.timeOutHours = vm.getTimeOutHourRange();
  },
  watch: {},
  methods: {
    getTimeInHourRange() {
      const vm = this;
      let timeIn = null;
      let timeInEnd = null;
      let res = vm.form.rental.checkin.split(":");
      let timeInRes = vm.form.rental.checkin_end.split(":");
      if (res[0] && res[1]) {
        timeIn = `${res[0]}:${res[1]}`;
        if (timeInRes[0] && timeInRes[1]) {
          timeInEnd = `${timeInRes[0]}:${timeInRes[1]}`;
        }
        let start = vm.hours.indexOf(timeIn);
        let end = vm.hours.indexOf(timeInEnd);
        console.log(start, end);
        if (start !== -1) {
          return end !== 1 && start < end
            ? vm.hours.slice(start, end + 1)
            : vm.hours.slice(start);
        } else {
          return vm.hours;
        }
      } else {
        return vm.hours;
      }
    },
    getTimeOutHourRange() {
      const vm = this;
      let timeOut;
      let res = vm.form.rental.checkout.split(":");
      if (res[0] && res[1]) {
        timeOut = `${res[0]}:${res[1]}`;
        let end = vm.hours.indexOf(timeOut);
        if (end !== -1) {
          return vm.hours.slice(0, end + 1);
        } else {
          return vm.hours;
        }
      } else {
        return vm.hours;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/form/preview/index.js